"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userConsolidateAssessmentResponseSchema = exports.userConsolidateAssessmentPayloadSchema = exports.grammarAssessmentSchema = exports.nativeAssessmentSchema = exports.pronunciationAssessmentSchema = exports.answerAssessmentSchema = void 0;
const zod_1 = require("zod");
const grammar_1 = require("./grammar");
const pronunciation_1 = require("./pronunciation");
const pronunciationWordSchema = zod_1.z.object({
    word: zod_1.z.string(),
    accuracyScore: zod_1.z.number(),
    label: pronunciation_1.pronunciationLabelSchema,
    encounters: zod_1.z.number(),
    contexts: zod_1.z
        .array(zod_1.z.object({
        context: zod_1.z.array(pronunciation_1.pronunciationWordContextSchema).optional(),
    }))
        .optional(),
});
const pronunciationPhonemeSchemaExtended = pronunciation_1.pronunciationPhonemeSchema.extend({
    encounters: zod_1.z.number().optional(),
});
exports.answerAssessmentSchema = zod_1.z.object({
    score: zod_1.z.number().nullish(),
});
exports.pronunciationAssessmentSchema = zod_1.z.object({
    score: zod_1.z.number().nullish(),
    wordsCount: zod_1.z.number(),
    uniqueWordsCount: zod_1.z.number(),
    uniqueMistakeWords: zod_1.z.array(pronunciationWordSchema),
    uniqueMistakeWordsCount: zod_1.z.number(),
    uniqueCorrectWords: zod_1.z.array(pronunciationWordSchema),
    uniqueCorrectWordsCount: zod_1.z.number(),
    phonemesCount: zod_1.z.number(),
    mistakenPhonemes: zod_1.z.array(pronunciationPhonemeSchemaExtended),
    mistakenPhonemesCount: zod_1.z.number(),
    correctPhonemes: zod_1.z.array(pronunciationPhonemeSchemaExtended),
    correctPhonemesCount: zod_1.z.number(),
});
exports.nativeAssessmentSchema = zod_1.z.object({
    score: zod_1.z.number().nullish(),
});
exports.grammarAssessmentSchema = zod_1.z.object({
    score: zod_1.z.number().nullish(),
    totalErrors: zod_1.z.number(),
    errors: zod_1.z.array(zod_1.z.object({ error: grammar_1.grammarErrorSchema, count: zod_1.z.number() })),
});
exports.userConsolidateAssessmentPayloadSchema = zod_1.z.object({
    score: zod_1.z.number().nullish(),
    pronunciation: exports.pronunciationAssessmentSchema,
    native: exports.nativeAssessmentSchema,
    grammar: exports.grammarAssessmentSchema,
    answer: exports.answerAssessmentSchema,
});
exports.userConsolidateAssessmentResponseSchema = exports.userConsolidateAssessmentPayloadSchema.extend({
    totalReviewsCount: zod_1.z.number(),
    activeLearnedWordsCount: zod_1.z.number(),
    passiveLearnedWordsCount: zod_1.z.number(),
});
//# sourceMappingURL=userConsolidatedAssessment.js.map